import { render, staticRenderFns } from "./WorkerPermissions.vue?vue&type=template&id=316c1d0c&scoped=true&"
import script from "./WorkerPermissions.vue?vue&type=script&lang=js&"
export * from "./WorkerPermissions.vue?vue&type=script&lang=js&"
import style0 from "./WorkerPermissions.vue?vue&type=style&index=0&id=316c1d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c1d0c",
  null
  
)

export default component.exports